import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import LayoutWrapper from './LayoutWrapper';
/**
 * @ignore
 */

function NotFoundRouteContent(_ref) {
  var component = _ref.component,
      render = _ref.render,
      renderNotFound = _ref.renderNotFound,
      rest = _objectWithoutProperties(_ref, ["component", "render", "renderNotFound"]);

  var nextProps = _extends({}, rest, {
    render: renderNotFound
  });

  return React.createElement(LayoutWrapper, nextProps);
}

NotFoundRouteContent.propTypes = {
  component: PropTypes.elementType,
  layout: PropTypes.func,
  render: PropTypes.func,
  renderNotFound: PropTypes.func
};
NotFoundRouteContent.defaultProps = {
  component: undefined,
  layout: null,
  render: undefined,
  renderNotFound: undefined
};
export default NotFoundRouteContent;